import { render, staticRenderFns } from "./medical_history.vue?vue&type=template&id=440b1a8c&scoped=true&"
import script from "./medical_history.vue?vue&type=script&lang=js&"
export * from "./medical_history.vue?vue&type=script&lang=js&"
import style0 from "./medical_history.vue?vue&type=style&index=0&id=440b1a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440b1a8c",
  null
  
)

component.options.__file = "medical_history.vue"
export default component.exports